var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgEmoji1(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.75 30.7C12.2018 30.7 15 30.3642 15 29.95C15 29.5357 12.2018 29.2 8.75 29.2C5.29822 29.2 2.5 29.5357 2.5 29.95C2.5 30.3642 5.29822 30.7 8.75 30.7Z",
    fill: "#65B1EF"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M22 31C26.9706 31 31 30.597 31 30.1C31 29.6029 26.9706 29.2 22 29.2C17.0294 29.2 13 29.6029 13 30.1C13 30.597 17.0294 31 22 31Z",
    fill: "#65B1EF"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M16 31C24.2843 31 31 24.2843 31 16C31 7.71573 24.2843 1 16 1C7.71573 1 1 7.71573 1 16C1 24.2843 7.71573 31 16 31Z",
    fill: "#FDE047"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M22.3497 23C21.6497 21.2 19.9497 20 15.9997 20C11.9997 20 10.3497 21.2 9.64974 23C9.29974 23.95 9.79974 25.5 9.79974 25.5C10.4497 27.45 10.3497 28 15.9997 28C21.6497 28 21.5497 27.45 22.1997 25.5C22.1997 25.5 22.7497 23.95 22.3497 23Z",
    fill: "#664E27"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M20.5 22.5C20.55 22.35 20.5 22.2 20.4 22.1C20.4 22.1 19.4 21 16 21C12.6 21 11.6 22.1 11.6 22.1C11.5 22.15 11.5 22.35 11.5 22.5L11.6 22.8C11.65 22.95 11.75 23.05 11.85 23.05H20.15C20.25 23.05 20.4 22.95 20.4 22.8L20.5 22.5Z",
    fill: "white"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M22.2495 30.25H25.6495C29.7495 25.3 24.8995 20.25 26.0995 15.35C24.9495 15.35 23.7995 16.6 22.6995 16.6C21.0995 21.35 26.3495 25.3 22.2495 30.25ZM9.74951 30.25H6.34951C2.24951 25.3 7.09951 20.25 5.89951 15.35C7.04951 15.35 8.19951 16.6 9.29951 16.6C10.8995 21.35 5.64951 25.3 9.74951 30.25Z",
    fill: "#65B1EF"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M20.3503 9.14997C21.8503 10.65 23.9503 11.4 26.0503 11.2C26.3503 11.15 26.5003 12.25 26.1503 12.3C23.7003 12.5 21.3003 11.65 19.6003 9.89997C19.3003 9.64997 20.1503 8.94997 20.3503 9.14997ZM6.00029 11.2C8.10029 11.4 10.2003 10.65 11.7003 9.14997C11.9003 8.94997 12.7503 9.64997 12.5003 9.89997C10.8003 11.65 8.35029 12.5 5.95029 12.3C5.50029 12.3 5.70029 11.2 6.00029 11.2Z",
    fill: "#917524"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M17.9503 15.15C20.0503 19.15 24.3003 19.15 26.4003 15.15C26.5003 14.95 26.2503 14.85 25.9003 14.65C23.8003 16.3 20.3503 16.15 18.4503 14.65C18.1503 14.85 17.8503 14.95 17.9503 15.15ZM5.60034 15.15C7.70034 19.15 11.9503 19.15 14.0503 15.15C14.1503 14.95 13.9003 14.85 13.5503 14.65C11.4503 16.3 8.00034 16.15 6.10034 14.65C5.75034 14.85 5.50034 14.95 5.60034 15.15Z",
    fill: "#664E27"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEmoji1);
export default __webpack_public_path__ + "static/media/emoji_1.690871ec817aa1d0c76a1f9f40f55cd5.svg";
export { ForwardRef as ReactComponent };